import { Component, h, Host, Prop } from '@stencil/core';
import { CssClassMap, IconSize, IconType, IconVariant } from './jui-icon.model';

@Component({
  tag: 'jui-icon',
  styleUrl: 'jui-icon.scss',
  shadow: true
})
export class JuiIcon {
  /**
   * Icon color: primary | secondary | success | info | warning | danger | light | dark | current
   */
  @Prop() color: IconVariant = IconVariant.primary;

  /**
   * Icon size: xxs | xs | sm | md | lg | xl
   */
  @Prop() size: IconSize = IconSize.md;

  /**
   * Icon type: material icon type filled or outlined
   */
  @Prop() type: IconType = IconType.filled;

  /**
   * Icon name: Google material icon name: https://fonts.google.com/icons?selected=Material+Icons
   */
  @Prop() name = 'cookie';
  /**
   * Icon disabled flag
   */
  @Prop({ attribute: 'disabled', reflect: true })
  disabled: boolean;

  /**
   * IsButton - but can also be just an icon
   */
  @Prop({ attribute: 'isButton' }) isButton = true;

  /**
   * Button title attribute
   */
  @Prop({ attribute: 'title', reflect: true })
  titleText = '';

  @Prop()
  cursor?;

  private getCssClassMap(): CssClassMap {
    return {
      [this.color]: true,
      [this.size]: true,
      [this.type === IconType.filled ? 'material-icons' : 'material-icons-outlined']: true
    };
  }

  private getCursor() {
    if (this.cursor) {
      return { cursor: this.cursor };
    }
    return null;
  }

  render() {
    const classMap = this.getCssClassMap();
    return (
      <Host>
        {this.isButton ? (
          <button
            data-testid="icon-test"
            class={classMap}
            disabled={this.disabled}
            title={this.titleText}
            type="button"
            style={this.getCursor()}
            aria-label={`${this.titleText.length ? this.titleText : 'default'} icon`}
          >
            {this.name}
          </button>
        ) : (
          <span
            data-testid="icon-test"
            class={classMap}
            title={this.titleText}
            aria-label={`${this.titleText.length ? this.titleText : 'default'} icon`}
          >
            {this.name}
          </span>
        )}
      </Host>
    );
  }
}
